import {
  BotGraphType,
  BotStatus,
  BotType,
  FilterType,
  LanguageNameSpaces,
} from "@shared/types";
import {
  TRAILING_PERCENT_ITEM_NAME,
  TRAILING_STOP_TYPE_ITEM_NAME,
  TRIGGER_TYPE_ITEM_NAME,
  TRIGGER_VALUE_ITEM_NAME,
} from "@shared/features/configuration/constants";
import { Steps } from "@shared/features/bots/BotForm/common/types";
import {
  dcaBotBacktestingFilters,
  myDCABotsFilters,
  myGridBotsFilters,
  myHedgingBotsFilters,
  mySignalsBotsFilters,
  myTradingViewBotsFilters,
  myTradingViewSignalsBotsFilters,
  signalsBotBacktestingFilters,
} from "@shared/slices/filters.slice";
import { MyBotsSort } from "@shared/features/bots/types";
import { TranslationKeys } from "@shared/common/i18n/types";

export const BotGraphTypeToDisplay = {
  [BotGraphType.PROFIT_BY_DAY]: "statistics.profit_by_day",
  [BotGraphType.ACCUMULATING_PROFIT]: "statistics.accumulated_profit",
} as const;

export const botsFilterTypeToTitle: {
  [key in FilterType]?: TranslationKeys<LanguageNameSpaces.COMMON>;
} = {
  [FilterType.TIME_FRAME]: "filters.titles.bot_create_time",
};

export const backtestingFilterTypeToTitle: {
  [key in FilterType]?: TranslationKeys<LanguageNameSpaces.COMMON>;
} = {
  [FilterType.TIME_FRAME]: "filters.titles.create_time",
};

export const VERTICAL_ACTIVE_TRADE_BREAKPOINT = 540;
export const ACTIVE_TRADE_ROWS_BREAKPOINT = 320;

export const BULK_UPDATE_BOTS_MUTATION_KEY = "bulkUpdateBots";

export const TRAILING_TOP_ITEM_NAME_TO_DATA_FIELD: Record<string, string> = {
  [TRAILING_STOP_TYPE_ITEM_NAME]: "type",
  [TRAILING_PERCENT_ITEM_NAME]: "value",
  [TRIGGER_TYPE_ITEM_NAME]: "trigger.type",
  [TRIGGER_VALUE_ITEM_NAME]: "trigger.value",
} as const;

export const TAB_TO_OBJECT_NAME: Record<
  Steps,
  TranslationKeys<LanguageNameSpaces.BOTS>
> = {
  [Steps.GENERAL]: "tabs.general",
  [Steps.ENTRIES]: "tabs.entries",
  [Steps.TAKE_PROFITS]: "tabs.take_profits",
  [Steps.STOP]: "tabs.stop",
  [Steps.ADVANCED]: "tabs.advanced",
};

export const BOT_TYPE_TO_FILTERS_SLICE = {
  [BotType.ASAP]: myDCABotsFilters,
  [BotType.TRADING_VIEW]: myTradingViewBotsFilters,
  [BotType.SIGNAL]: mySignalsBotsFilters,
  [BotType.GRID]: myGridBotsFilters,
  [BotType.TRADING_VIEW_SIGNALS]: myTradingViewSignalsBotsFilters,
  [BotType.HEDGING]: myHedgingBotsFilters,
};

export const BOT_TYPE_TO_BACKTESTING_FILTERS_SLICE = {
  [BotType.ASAP]: dcaBotBacktestingFilters,
  [BotType.SIGNAL]: signalsBotBacktestingFilters,
};

export const BOT_TYPE_TO_DISPLAY_NAME: Record<
  BotType,
  TranslationKeys<LanguageNameSpaces.BOTS>
> = {
  [BotType.ASAP]: "bot_types.dca",
  [BotType.TRADING_VIEW]: "bot_types.trading_view",
  [BotType.SIGNAL]: "bot_types.signals",
  [BotType.GRID]: "bot_types.grid",
  [BotType.TRADING_VIEW_SIGNALS]: "bot_types.trading_view_signals",
  [BotType.HEDGING]: "bot_types.hedging",
};

export const USING_CHANNEL_SETTING = "messages.info.using_channel_settings";

export const BOT_STATUS_TO_HIDE = [
  BotStatus.DELETED,
  BotStatus.EDITED,
  BotStatus.CLIENT_DELETED,
];
export const CHANNEL_CONFIGURATIONS_SORTS = new Set([
  MyBotsSort.NAME,
  MyBotsSort.CREATED,
]);
export const SIGNALS_BOTS_SORTS = new Set([
  MyBotsSort.LAST_TRADE_OPENED,
  MyBotsSort.NAME,
  MyBotsSort.TOTAL_PROFIT,
  MyBotsSort.CLOSED_TRADES,
  MyBotsSort.OPEN_TRADES,
  MyBotsSort.GROUP,
  MyBotsSort.CREATED,
  MyBotsSort.AMOUNT,
]);
export const TRADING_VIEW_SIGNALS_BOTS_SORTS = new Set([
  MyBotsSort.NAME,
  MyBotsSort.SYMBOL,
  MyBotsSort.GROUP,
  MyBotsSort.CREATED,
  MyBotsSort.AMOUNT,
]);
export const HEDGING_BOTS_SORTS = new Set([
  MyBotsSort.NAME,
  MyBotsSort.TOTAL_PROFIT,
  MyBotsSort.CLOSED_TRADES,
  MyBotsSort.SYMBOL,
  MyBotsSort.CREATED,
  MyBotsSort.AMOUNT,
]);

export const FIRST_ENTRY_AS_MARKET_FORM_ITEM_TITLE =
  "forms.first_entry_as_market";

export const USD_ALTERNATIVE_PAIRS = ["USDT", "USD", "USDC"];
export const TV_ALERT_SYMBOL = "From TV Alert";
